/* KIDCO: show the product's second image when a card is hovered (desktop only) */
(function () {
  if (!window.matchMedia || !matchMedia('(hover:hover) and (pointer:fine)').matches) return;
  var cache = {};
  function sized(u, w) {
    if (!u) return u;
    if (u.indexOf('//') === 0) u = 'https:' + u;
    return u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }
  function getSecond(handle) {
    if (!cache[handle]) {
      cache[handle] = fetch((window.KIDCO_ROOT || '/') + 'products/' + handle + '.js')
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (p) { return p && p.images && p.images.length > 1 ? p.images[1] : null; })
        .catch(function () { return null; });
    }
    return cache[handle];
  }
  function setup(card) {
    if (card.__kh) return;
    card.__kh = 1;
    var link = card.querySelector('a[href*="/products/"]');
    var img = card.querySelector('img');
    if (!link || !img) return;
    var handle = (link.getAttribute('href').split('/products/')[1] || '').split('?')[0].split('#')[0].split('/')[0];
    if (!handle) return;
    getSecond(handle).then(function (src) {
      if (!src) return;
      var box = img.parentElement;
      var ics = getComputedStyle(img);
      if (ics.position === 'static' && getComputedStyle(box).position === 'static') box.style.position = 'relative';
      var two = new Image();
      two.className = 'k-img2';
      two.alt = '';
      two.setAttribute('aria-hidden', 'true');
      two.decoding = 'async';
      two.src = sized(src, 800);
      two.style.objectFit = ics.objectFit || 'cover';
      two.style.borderRadius = ics.borderRadius;
      img.insertAdjacentElement('afterend', two);
      card.classList.add('k-has-img2');
    });
  }
  var io = 'IntersectionObserver' in window ? new IntersectionObserver(function (es) {
    es.forEach(function (e) { if (e.isIntersecting) { io.unobserve(e.target); setup(e.target); } });
  }, { rootMargin: '300px' }) : null;
  function scan() {
    document.querySelectorAll('[data-kcard]').forEach(function (c) {
      if (c.__khq) return; c.__khq = 1;
      c.addEventListener('mouseenter', function () { setup(c); }, { once: true });
      io ? io.observe(c) : setup(c);
    });
  }
  function start() {
    scan();
    new MutationObserver(function () { scan(); }).observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();